import { btoa, atob } from 'abab';
// this all seems to work but for some reason eslint doesn't like the js-cookie library.
// eslint-disable-next-line import/no-unresolved
import Cookies from 'js-cookie';

const access_token = 'access-token';
const auth_token = 'auth_token';
const uid = 'uid';
const expiry = 'expiry';

export function findToken() {
  const tokenSearchMethods = [extractSearchParams(), extractAuthHeaders()];
  let discoveredToken = [];
  for (const tokenSearchMethod of tokenSearchMethods) {
    const token = tokenSearchMethod;
    if (token && token.auth_token) {
      discoveredToken = token;
      break;
    }
  }
  return discoveredToken;
}

function extractSearchParams() {
  const url = new URL(window.location);
  if (url.searchParams.get(auth_token)) {
    const token = createToken(
      url.searchParams.get(auth_token),
      url.searchParams.get('client_id'),
      url.searchParams.get(expiry),
      url.searchParams.get(uid),
    );
    return token;
  }

  if (url.searchParams.get(access_token)) {
    const token = createToken(
      url.searchParams.get(access_token),
      url.searchParams.get('client'),
      url.searchParams.get(expiry),
      url.searchParams.get(uid),
    );
    return token;
  }

  return null;
}

function extractAuthHeaders() {
  const authHeaders = Cookies.get('auth_headers');
  if (!authHeaders) {
    return null;
  }
  const parsedAuthHeaders = JSON.parse(authHeaders);
  const token = createToken(
    parsedAuthHeaders['access-token'],
    parsedAuthHeaders['client'],
    parsedAuthHeaders[expiry],
    parsedAuthHeaders[uid],
  );
  return token;
}

function createToken(tokenValue, clientValue, expiryValue, uidValue) {
  const token = [];
  token.auth_token = tokenValue;
  token.client_id = clientValue;
  token.expiry = expiryValue;
  token.uid = uidValue;
  return token;
}

function createCombinedAccessCookie(token) {
  const combinedAccess = btoa(['', token.auth_token, token.client_id, token.uid, token.expiry].join('|'));
  return combinedAccess;
}

export function createClassicToken(combinedAccess) {
  const decodedCombinedAccess = atob(combinedAccess);
  const combinedAccessProperties = decodedCombinedAccess.split('|');
  const classicTokenProperties = combinedAccessProperties.reverse();

  const classicToken = {
    'access-token': classicTokenProperties[3],
    'token-type': 'Bearer',
    client: classicTokenProperties[2],
    expiry: classicTokenProperties[0],
    uid: classicTokenProperties[1],
  };

  return JSON.stringify(classicToken);
}

export function storeCookieFromToken(token) {
  const combinedAccess = createCombinedAccessCookie(token);
  storeCombinedAccessCookie(combinedAccess);

  const classicToken = createClassicToken(combinedAccess);
  storeClassicCookie(classicToken);
}

export function storeCombinedAccessCookie(combinedAccess) {
  Cookies.set('combinedAccess', combinedAccess, { path: '/', sameSite: 'None', secure: true });
}

export function storeClassicCookie(classicToken) {
  Cookies.set('auth_headers', classicToken, { path: '/', sameSite: 'None', secure: true });
}

export function hasCombinedAccessCookie() {
  const cookie = Cookies.get('combinedAccess');
  return cookie;
}
